import { AppError } from '@/domain/ErrorApp.ts';
import { SingleTab } from '@/domain/singleTab.ts';
import { ItemMenu } from '@/domain/menu.ts';

export interface GlobalState {
  isDark: boolean;
  error?: AppError;
  tabs: SingleTab[];
  tabsPageMap: Record<string, ItemMenu>;
  activeTab?: string;
  stateVideo?: boolean;
  reloadProjectList?: boolean;
}

export const initialState: GlobalState = {
  isDark: true,
  tabs: [],
  tabsPageMap: {},
};
